<script setup lang="ts">
import generateQrCode from 'sepa-payment-qr-code'
import QrCode from './QrCode.vue'
import { defineProps } from 'vue'
import { getPaymentQrCodeType } from '../../utilities/usePlatformSettings'
import PaymentQrCodeSwiss from './PaymentQrCodeSwiss.vue'

const props = defineProps<{
    name: string
    iban: string
    bic?: string
    amount: number
    reference: string
}>()

// https://de.wikipedia.org/wiki/EPC-QR-Code
const epcTransferQrString = generateQrCode({
    name: props.name,
    iban: props.iban,
    amount: props.amount,
    unstructuredReference: props.reference,
})
</script>

<template>
    <PaymentQrCodeSwiss
        v-if="getPaymentQrCodeType() === 'swiss'"
        :amount="amount"
        :reference="reference"></PaymentQrCodeSwiss>
    <QrCode v-else :value="epcTransferQrString" />
</template>
